// extracted by mini-css-extract-plugin
export var lg = "_2k-4";
export var md = "_2k-3";
export var sm = "_2k-2";
export var xs = "_2k-1";
export var xxs = "_2k-0";